interface OfficialAttendingContext {
  canViewAttendanceInfo: boolean
  isGenericGame: boolean
  isGameCompleted: boolean
}

/**
 * Team Officials "Attending" cell: whether the official was at the game. Only
 * known once the game is over, and hidden from viewers who can't see
 * attendance.
 */
export const getOfficialAttendingLabel = (
  isAttending: boolean | null | undefined,
  {
    canViewAttendanceInfo,
    isGenericGame,
    isGameCompleted,
  }: OfficialAttendingContext
): string => {
  if (!canViewAttendanceInfo) {
    return ''
  }
  if (isGenericGame || !isGameCompleted) {
    return '-'
  }
  return isAttending ? 'Attending' : 'Not Attending'
}
